import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProjectsComponent } from './projects.component';
import { ProjectContentComponent } from './project-content/project-content.component';
import { CreateProjectQuestionnaireComponent } from './project-content/project-questionnaire/create-project-questionnaire/create-project-questionnaire.component';
import { ConversationPageComponent } from './project-content/project-conversation/conversation-page/conversation-page.component';
import { AssessmentPageComponent } from './project-content/project-assessment/assessment-page/assessment-page.component';
import { ViewAssessmentConversationComponent } from './project-content/project-assessment/assessment-page/view-assessment-conversation/view-assessment-conversation.component';
import { ViewAssessmentExamineeReportComponent } from 'src/app/shared/components/view-assessment-examinee-report/view-assessment-examinee-report.component';

const routes: Routes = [
	{ path: '', component: ProjectsComponent, children: [
		{ path: ':projectid', children: [
			{ path: '', component: ProjectContentComponent },
			{ path: 'conversation/:conversationid', component: ConversationPageComponent },
			{ path: 'assessment/:assessmentid', component: AssessmentPageComponent },
			{ path: 'assessment/:assessmentid/conversation/:conversationid', component: ViewAssessmentConversationComponent },
			{ path: 'assessment/:assessmentid/examinee/:examineid', component: ViewAssessmentExamineeReportComponent },
			{ path: 'examinee/:examineid', component: ViewAssessmentExamineeReportComponent },
			{ path: 'questionnaire/create', component: CreateProjectQuestionnaireComponent },
			{ path: 'questionnaire/edit/:questionnaireid', component: CreateProjectQuestionnaireComponent },
		] }
	] },
	{ path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProjectsRoutingModule { }
